function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M22.222 13.575a4.476 4.476 0 104.476 4.476 4.476 4.476 0 00-4.476-4.476zm0 6.821a2.345 2.345 0 110-4.689 2.345 2.345 0 110 4.689z"
}), React.createElement("path", {
  d: "M40.073 3.343L10.979.043a4 4 0 00-3.144.906A4.05 4.05 0 006.29 3.72l-.533 4.369H4.1a4.282 4.282 0 00-4.1 4.42v21.794a4.05 4.05 0 003.941 4.155h29.418a4.374 4.374 0 004.476-4.156v-.853a5.328 5.328 0 002.025-.853 4.423 4.423 0 001.54-2.872L43.851 8.09a4.316 4.316 0 00-3.778-4.747zM35.7 34.303a2.244 2.244 0 01-2.341 2.021H4.1a1.918 1.918 0 01-1.974-1.861v-4.104l8.259-6.075a2.558 2.558 0 013.3.16L19.5 29.56a5.009 5.009 0 003.144 1.172 4.849 4.849 0 002.558-.693l10.5-6.075v10.339zm0-12.842l-11.613 6.763a2.718 2.718 0 01-3.144-.266l-5.861-5.169a4.743 4.743 0 00-5.915-.213l-7.034 5.119V12.509A2.151 2.151 0 014.1 10.217h29.259a2.451 2.451 0 012.341 2.292v8.952zm6.023-13.663v.021l-2.5 21.634a1.812 1.812 0 01-.693 1.439c-.213.213-.693.32-.693.426V12.509a4.583 4.583 0 00-4.476-4.423H7.888l.48-4.156a2.451 2.451 0 01.8-1.385 2.451 2.451 0 011.6-.426l29.041 3.357a2.131 2.131 0 011.918 2.322z"
}));

var SvgGalleryIcon = function SvgGalleryIcon(props) {
  return React.createElement("svg", _extends({
    width: 43.881,
    height: 38.46
  }, props), _ref);
};

export default __webpack_public_path__ + "b761b53e1c370c471ba386087ea0d644.svg";
export { SvgGalleryIcon as ReactComponent };